import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTFUNNELONBEHALFUSERPHONEITEMBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "placeholder",
  "required"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelOnBehalfUserPhoneItemBlockDescriptor: _generatedCartFunnelOnBehalfUserPhoneItemBlockDescriptor,
  cartFunnelOnBehalfUserPhoneItemBlockBlocDefinition,
  cartFunnelOnBehalfUserPhoneItemBlockDashboardLayout,
  cartFunnelOnBehalfUserPhoneItemBlockConfig,
  cartFunnelOnBehalfUserPhoneItemBlockResolveConfig,
  cartFunnelOnBehalfUserPhoneItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / On behalf user phone input",
    componentType: 'CartFunnelOnBehalfUserPhoneItemBlockComponent',
    category: 'cart',
    description: "Cart funnel / On behalf user phone input.",
    keywords: [],
    allowedIn: [
      { bloc: "CartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-on-behalf-user-phone-item.title.label",
        help: "pages.blocks.cart-funnel-on-behalf-user-phone-item.title.help",
      }
    }),
    placeholder: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-on-behalf-user-phone-item.placeholder.label",
      }
    }),
    required: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.cart-funnel-on-behalf-user-phone-item.required.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-funnel-on-behalf-user-phone-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-on-behalf-user-phone-item.fieldset.field.label",
            fields: ["title", "placeholder", "required"],
          },
        ],
      },
    ],
  })
);

export function cartFunnelOnBehalfUserPhoneItemBlockDescriptor(): IBlockDescriptor;
export function cartFunnelOnBehalfUserPhoneItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelOnBehalfUserPhoneItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelOnBehalfUserPhoneItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelOnBehalfUserPhoneItemBlockDescriptor, cartFunnelOnBehalfUserPhoneItemBlockProperties, fieldOrder);
}

export {
  cartFunnelOnBehalfUserPhoneItemBlockBlocDefinition,
  cartFunnelOnBehalfUserPhoneItemBlockDashboardLayout,
  cartFunnelOnBehalfUserPhoneItemBlockProperties,
  cartFunnelOnBehalfUserPhoneItemBlockConfig,
  cartFunnelOnBehalfUserPhoneItemBlockResolveConfig,
};

export type CartFunnelOnBehalfUserPhoneItemBlockConfig = typeof cartFunnelOnBehalfUserPhoneItemBlockConfig;
